import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "educationTab" }
const _hoisted_2 = { class: "wizard-action justify-end" }
const _hoisted_3 = { class: "d-flex ga-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EducationList = _resolveComponent("EducationList")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_EducationRegister = _resolveComponent("EducationRegister")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "text-center text-md-left"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("h1", null, "Education", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "tab-item-card",
              loading: _ctx.dataLoading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Add Education History ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoBox, { title: "Add your Education History Here, including your previous qualifications and any current courses" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "primary_btn w-100",
                              "prepend-icon": "mdi-plus",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddEducation = true))
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Add Education")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_EducationList, {
                      isHiringmanager: _ctx.isHiringmanager,
                      onRemove: _ctx.remove,
                      onEdit: _ctx.edit,
                      educationList: _ctx.items,
                      addLoading: _ctx.addLoading
                    }, null, 8, ["isHiringmanager", "onRemove", "onEdit", "educationList", "addLoading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_dialog, {
                  persistent: "",
                  modelValue: _ctx.showAddEducation,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAddEducation) = $event)),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.showAddEducation = false), ["esc"])),
                  "max-width": "1000px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EducationRegister, {
                      isHiringmanager: _ctx.isHiringmanager,
                      editingItem: _ctx.editingItem,
                      onSaved: _ctx.saveEducation,
                      onScrollToElement: _ctx.scrollToElement,
                      onCancelEditing: _ctx.cancelEditing,
                      addLoading: _ctx.addLoading,
                      gettingEducation: _ctx.isGettingEducation,
                      isAfterSignUp: _ctx.isAfterSignUp
                    }, null, 8, ["isHiringmanager", "editingItem", "onSaved", "onScrollToElement", "onCancelEditing", "addLoading", "gettingEducation", "isAfterSignUp"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_dialog, {
                  persistent: "",
                  modelValue: _ctx.showRemoveConfirm,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showRemoveConfirm) = $event)),
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.showRemoveConfirm = false), ["esc"])),
                  "max-width": "400px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_confirm_dialog, {
                      loading: _ctx.deleteLoading,
                      onConfirm: _ctx.confirmDelete,
                      onCancel: _cache[3] || (_cache[3] = ($event: any) => {
                _ctx.showRemoveConfirm = false;
                _ctx.deleteLoading = false;
              }),
                      message: _ctx.confirmModel
                    }, null, 8, ["loading", "onConfirm", "message"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.isAfterSignUp)
                  ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            (!_ctx.isHiringmanager)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  class: "primary_btn",
                                  onClick: _ctx.goBack,
                                  disabled: _ctx.addLoading || _ctx.deleteLoading,
                                  loading: _ctx.addLoading || _ctx.deleteLoading,
                                  "prepend-icon": "mdi-chevron-left"
                                }, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode("Back")
                                  ])),
                                  _: 1
                                }, 8, ["onClick", "disabled", "loading"]))
                              : _createCommentVNode("", true),
                            (!_ctx.isHiringmanager)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 1,
                                  class: "primary_btn",
                                  onClick: _ctx.goNext,
                                  disabled: _ctx.addLoading || _ctx.deleteLoading,
                                  loading: _ctx.addLoading || _ctx.deleteLoading,
                                  "append-icon": "mdi-chevron-right"
                                }, {
                                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createTextVNode("Next ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick", "disabled", "loading"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}